import React, { useCallback, useState } from 'react';
import { TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { changeTicketSummary } from '../../../../store/tickets';
import { TICKET_CREATE } from '../../../../router/routes';

import { ReactComponent as SearchIcon } from '../../../../assets/search.icon.svg';
import Button from '../../../../components/Button/Button';

import useStyles from '../../styles';
import { tt } from '@i18n/tt';
import { ThunkGetTickets } from '../../../../store/tickets/thunks';
import { TicketsParamsSelector } from '../../../../store/tickets/selectors';

const TicketsSearch: React.FC = () => {
  const [searchValue, setSearchValue] = useState<string>('');
  const params = useAppSelector(TicketsParamsSelector);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const classes = useStyles();

  const handleSearch = useCallback(
    (search: string) => {
      dispatch(changeTicketSummary(search));
      dispatch(ThunkGetTickets({ params: { ...params, search } }));
    },
    [dispatch],
  );

  return (
    <div className={classes.searchContainer}>
      <Button
        text={tt('pages.tickets.createTicketButton')}
        onClick={() => {
          navigate(TICKET_CREATE);
        }}
        fullWidth
      />

      <TextField
        placeholder={tt('common.search')}
        variant="outlined"
        fullWidth
        value={searchValue}
        onChange={e => {
          setSearchValue(e.target.value);
        }}
        onKeyDown={event => {
          if (event.key === 'Enter') {
            handleSearch(searchValue);
          }
        }}
        InputProps={{
          startAdornment: (
            <div>
              <SearchIcon
                className={classes.searchIcon}
                onClick={() => {
                  handleSearch(searchValue);
                }}
              />
            </div>
          ),
        }}
      />
    </div>
  );
};

export default TicketsSearch;
